import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './i18n';
import './dayjs';
import 'react-circular-progressbar/dist/styles.css';

const sentryDsn =
  process.env.REACT_APP_SENTRY_DNS ||
  'https://e6c2a2bc7ab0f483bfe69f7e461e9d3f@o4509751414751232.ingest.de.sentry.io/4509757351067728';
const isProduction = process.env.NODE_ENV === 'production';

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      new BrowserTracing(),
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: isProduction ? 0.2 : 1.0,
    replaysSessionSampleRate: isProduction ? 0.1 : 0,
    replaysOnErrorSampleRate: isProduction ? 0.3 : 0,
    beforeSend(event, hint) {
      const error = hint.originalException;
      // Filter out rate limit errors to prevent feedback loop
      if (error && typeof error === 'object' && 'message' in error) {
        const message = String(error.message);
        if (message.includes('429') || message.includes('Too Many Requests')) {
          return null;
        }
      }
      // Filter out OAuth2 errors in development
      if (!isProduction && event.request?.url?.includes('/oauth2/token')) {
        console.warn('OAuth2 token error (not sent to Sentry in dev):', event);
        return null;
      }
      return event;
    },
  });
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
